import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

export function useDispatchBackup() {
  const [exporting, setExporting] = useState(false);
  const [exportError, setExportError] = useState("");
  const backupTickets = async () => {
    if (exporting) return;
    setExporting(true);
    setExportError("");
    try {
      const { data } = await api.get("/fractank/dispatches/export.csv", { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `rental_dispatch_backup_${new Date().toISOString().replace(/[:.]/g, "-")}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      toast.success("All-ticket CSV backup download started");
    } catch {
      const message = "Could not download the ticket backup. Please try again.";
      setExportError(message);
      toast.error(message);
    } finally { setExporting(false); }
  };
  return { exporting, exportError, backupTickets };
}
